module.exports = "<ul class=ipt_elmList> <% _.each(regions, function(region) { %> <% if (state.city0 || state.country0 !== region.code) { %> <li class=\"ipt_elmList_item ipt_linkBox <%= +region.count ? 'forcia-arrival': 'forcia-css-disabled'%>\" data-state='{\"country1\": \"<%= region.code %>\", \"subLayer\": \"city1\"}'><a class=\"inr icon_arwWT_rgt\"><%= region.name %> [<%= numFormat(region.count) %>]</a> <% } %> </li> <% }); %> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./web/WEB-INF/js/client/search/templates/country1.template.html
// module id = 58
// module chunks = 2